import type {
  ScheduleIdleWork,
  ScheduleIdleWorkCallback,
} from "./types";

const IDLE_TIMEOUT_MS = 200;
const FALLBACK_DELAY_MS = 0;

const isRequestIdleCallbackSupported = (): boolean =>
  typeof window.requestIdleCallback === "function";

const runFallback = (callback: ScheduleIdleWorkCallback): number =>
  window.setTimeout(() => {
    callback({
      timeRemaining: () => Number.POSITIVE_INFINITY,
      didTimeout: false,
    });
  }, FALLBACK_DELAY_MS);

export const scheduleIdleWork: ScheduleIdleWork = (callback) => {
  if (isRequestIdleCallbackSupported()) {
    const handle = window.requestIdleCallback(callback, {
      timeout: IDLE_TIMEOUT_MS,
    });
    return {
      cancel: () => window.cancelIdleCallback(handle),
    };
  }

  const timeoutHandle = runFallback(callback);
  return {
    cancel: () => window.clearTimeout(timeoutHandle),
  };
};
